// extracted by mini-css-extract-plugin
export default {"search":"Forms_search__gVww1","description":"Forms_description__aTW6l"};